import styled from 'styled-components';

const ContentHeader = styled.section`
  padding: 15px 15px 0 15px;
  position: relative;
`;

export default ContentHeader;
